import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { menulist } from '../class/status';
import { page } from '../../comm/class/status';

@Component({
  selector: 'app-findsth',
  templateUrl: './findsth.component.html',
  styleUrls: ['./findsth.component.css']
})
export class FindsthComponent implements OnInit {
  search_model:string = '';
  search_type:string='1';
  menu_list:menulist = [{id:'1',name:'自我介紹'},{id:'2',name:'聊天紀錄'},{id:'-1',name:'全部'}];
  tab_list:menulist = [{id:'0',name:'設定資訊'},{id:'1',name:'聊天紀錄'}]
  m_model:string='-1';
  now:string='0';
  data:any=[];
  top_info:any=[];
  edit_data:any=[];
  detail_data:any=[];
  loading:boolean=false;

  tcontent = [
    {title:'發送時間',content:'create_dt'},
    {title:'國碼',content:'area'},
    {title:'電話',content:'phone'},
    {title:'動作',content:'aname'},
    {title:'呼叫時間',content:'calltime',type:3},
    {title:'二次驗證',content:'twocall',type:3},
  ];

  pageobj:page = {page:0,count:10,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  constructor(public httpClient: HttpClient,) { }
  ngOnInit(): void {
    this.init_list();
  }

  init_list(){
    const body = {page: this.pageobj.page,count:this.pageobj.count,
    search:this.search_model
    };
    this.loading = true;
    this.httpClient.post<any>("/trace/phone_record.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data;
        this.top_info = res.top_info;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
        this.top_info = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
      console.log('res',res);
    });
  }


  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

}
